import React from "react";

const DevLog2 = React.forwardRef((props, ref) => {
  const flexStyle = {
    display: "flex",
    flexWrap: "wrap",
    width: "max-content",
    maxWidth: "100%",
    minWidth: "min(20rem, 100%)",
    alignItems: "center",
  };

  const heading = "Introducing Heirlooms";
  const date = "28th January 2022";
  return (
    <div ref={ref}>
      {/* // ! Do not change positions */}
      <h1>{heading}</h1>
      <h4>{date}</h4>
      <div>
        <p>
          <strong>
            Hello everyone and welcome to our second Discovery Log!
          </strong>
        </p>

        <div>
          <br />
          <p>
            We've been working on Project SteelWalker for well over three months
            now and we've come a long way since we've started. We have so much
            to share with everyone about our game and we hope we can make these
            Discovery Logs a weekly tradition so we can cover a lot of what we
            have to show.
          </p>
          <br />
          <p>
            With the project's focus on cooperative teamwork between two
            players, we decided to grant players roles by giving them differing
            tools and abilities. If both playable characters have the same
            abilities, there are fewer creative possibilities for the team to
            make unique puzzles that require both players to complete them.
          </p>
          <br />
          <p>
            Each player will be granted unique tools we call Heirlooms; Each
            with a primary and a secondary ability. These abilities include
            combat, interaction and traversal. At the moment, each player has
            one tool implemented - One being a pair of daggers and the other
            being a Shield.
          </p>
          <br />
          <div style={flexStyle}>
            <p
              style={{
                width: "min(40rem, 100%)",
                minWidth: "min(15rem, 100%)",
                marginRight: "auto",
              }}
            >
              The first tool we'll be taking a look at today is the Daggers.
              When equipped, their primary ability is to allow players to scale
              up specific walls to reach areas that are otherwise unreachable.
              The alternate use for the Daggers is to cut through cables or
              overgrown brush to allow progress through puzzles and areas. For
              example, cutting the cables to lower a drawbridge will give the
              other player a path to cross.
            </p>
            <img
              src="../logImages/log2/DaggerAsset.png"
              alt="Dagger Asset"
              style={{ maxWidth: "50%", width: "10rem", marginRight: "2rem" }}
            />
          </div>
          <br />
          <div style={flexStyle}>
            <p
              style={{
                width: "min(40rem, 100%)",
                minWidth: "min(15rem, 100%)",
                marginRight: "auto",
              }}
            >
              The second Heirloom we'll be taking a look at is the Shield. Its
              primary ability is to protect the players standing behind it from
              attacks or certain hazards that are directed towards them. For
              example, the game features vents that blow a strong current of
              steam that pushes players back. The players may use the Shield to
              protect themselves from the force of these vents. The Shield's
              alternate ability is to send out a shockwave that can be used to
              send the other player flying up to areas they can't normally
              reach.
            </p>
            <img
              src="../logImages/log2/ShieldAsset.png"
              alt="Dagger Asset"
              style={{ maxWidth: "50%", width: "10rem", marginRight: "2rem" }}
            />
          </div>
          <br />
          <p>
            Thanks to the way these tools are designed, players are strongly
            encouraged to work together to progress. Our goal is to invoke as
            much player co-operation as possible, and we will provide&nbsp; more
            and more opportunities for players to use their tools together as
            the game progresses.
          </p>
          <br />
          <p>
            Recently, development has begun on the final pair of tools, one
            being a throwable javelin and the other being a grappling hook. Look
            forward to seeing a Discovery Log in the future that delves deeper
            into them. Until then, stay tuned to hear more about what you can
            expect from Project SteelWalker next week!
          </p>
          <br />- Particle Interactive
        </div>
      </div>
    </div>
  );
});

export default DevLog2;
